/**
 * Sort Icons Components
 * Exact copy from Flow project
 */

import React from 'react';
import classNames from 'classnames';

export interface iIconProps {
  isRelative?: boolean;
}

export const IconSortDefault = (props: iIconProps) => {
  const { isRelative } = props;
  return (
    <i
      className={classNames({
        icon: true,
        'icon-sort-default': true,
        relative: isRelative,
      })}
    ></i>
  );
};

export const IconSortAsc = (props: iIconProps) => {
  const { isRelative } = props;
  return (
    <i
      className={classNames({
        icon: true,
        'icon-sort-asc': true,
        relative: isRelative,
      })}
    ></i>
  );
};

export const IconSortDesc = (props: iIconProps) => {
  const { isRelative } = props;
  return (
    <i
      className={classNames({
        icon: true,
        'icon-sort-desc': true,
        relative: isRelative,
      })}
    ></i>
  );
};
